export const rawHtmlToReact = (rawHtml: string) => {
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlInput = rawHtml;
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = htmlToReactParser.parse(htmlInput);
  return reactElement;
};
